import * as React from "react";
import { IQuantity, Quantity } from "../../../../common/models/quantity.model";
import optimaIcon from './favicon-optima.png';
import { setListErr, setListMessage } from "../../../../../config/redux/alerts/alertsActions";
import { syncOptima, retryCuoDeliveryReport } from "../../../../../connectors/orders/connectors";

interface ICompletedActions {
    openPanelToCorrect: void,
    openPanelSyncOrder: void,
    openPanel: void
}

export const generateCompleted = (quantity: IQuantity, actions: ICompletedActions, selectedOrder?: any, dispatch?: any) => {
    const { REACT_APP_OPTIMA_ENABLED } = process.env;

    switch (quantity) {
        case Quantity.NONE:
            return [];
        case Quantity.ONE:
            if (!selectedOrder.Manually) {
                let arr: any[] = [
                    {
                        key: "see",
                        text: "Zobacz",
                        iconProps: { iconName: "textDocument" },
                        onClick: actions.openPanel,
                    },
                    {
                        key: "correct",
                        text: "Popraw",
                        iconProps: { iconName: "SingleColumnEdit" },
                        onClick: actions.openPanelToCorrect,
                    }
                ];
                if(REACT_APP_OPTIMA_ENABLED === "1" && selectedOrder.optimaNumber == null){
                    arr.push(
                        {
                            key: "sync",
                            text: "Synchronizuj",
                            onRenderIcon: () => {
                                return <img src={optimaIcon}  alt="optima" style={{maxHeight: '16px'}}/>;
                            },
                            onClick: async () => {
                               const response : any = await syncOptima (selectedOrder.id)
                               if(dispatch && typeof dispatch === 'function') {
                                   if (response.data.success === false) {
                                    dispatch(setListErr("Wystąpił błąd synchronizacji"))
                                   } else if (response.data.success === true) {
                                    dispatch(setListMessage("Synchronizacja przebiegła pomyślnie"))
                                    selectedOrder.optimaNumber = response.data.data
                                   }
                               }
                              },
                            });
                }
                if(REACT_APP_OPTIMA_ENABLED === "1" && selectedOrder.optimaNumber == null){
                    arr.push(
                        {
                            key: "seee",
                            text: "Ręczna synchronizacja z Optimą",
                            onRenderIcon: () => {
                                return <img src={optimaIcon}  alt="optima" style={{maxHeight: '16px'}}/>;
                            },
                            onClick: actions.openPanelSyncOrder,
                        })
                }
                if (selectedOrder && selectedOrder.cuoOrderMappingId != null && selectedOrder.cuoDeliveryReportSent === false) {
                    arr.push({
                        key: "retry-cuo-delivery-report",
                        text: "Synchronizacja z CUO",
                        iconProps: { iconName: "Sync" },
                        onClick: async () => {
                            const response: any = await retryCuoDeliveryReport(selectedOrder.id);
                            if (dispatch && typeof dispatch === 'function') {
                                if (response && response.data === true) {
                                    dispatch(setListMessage("Raport do CUO wysłany"));
                                    selectedOrder.cuoDeliveryReportSent = true;
                                } else {
                                    dispatch(setListErr("Nie udało się wysłać raportu do CUO"));
                                }
                            }
                        }
                    });
                }


                return arr;
            }
            return [
                {
                    key: "see",
                    text: "Zobacz",
                    iconProps: { iconName: "textDocument" },
                    onClick: actions.openPanel,
                },
                {
                    key: "correct",
                    text: "Popraw",
                    iconProps: { iconName: "SingleColumnEdit" },
                    onClick: actions.openPanelToCorrect,
                }
            ];
        case Quantity.MANY:
            return [];
    }
};